<adapt-dashboard-element name="Cultural Index"
                         [url]="url$ | async">
    <div class="chart-wrapper">
        <adapt-ci-orbit-chart [compact]="true">
        </adapt-ci-orbit-chart>
    </div>
</adapt-dashboard-element>
